import { Navigate } from 'react-router-dom';

export const PublicRoute = ({
  isAuthenticated,
  children,
}: {
  isAuthenticated: string;
  children: React.ReactNode;
}) => {
  return isAuthenticated === 'authenticated' ? (
    <Navigate to="/dashboard" />
  ) : (
    children
  );
};
